import styled from 'styled-components';

import { FontFamily, TextAlignName } from 'types';

import { pickColor } from 'themes/helpers/pickColor';
import { FontScaleName, getFontScale } from 'themes/mixins/getFontScale';

import { Headline } from 'components/Headline';
import { Icon } from 'components/Icons';

import { ButtonMotives, pickMotive } from './buttonMotives.data';

export type StyledButtonIconProps = {
  $iconSize?: string;
};

export type StyledButtonProps = {
  motive?: ButtonMotives;
  scale?: FontScaleName;
  fontFamily?: FontFamily;
  textAlign?: TextAlignName;
  minWidth?: string;
};

const Button = styled.button<StyledButtonProps>`
  display: flex;
  align-items: center;

  margin: 0;
  padding: 0;

  background-color: transparent;
  color: inherit;
  border: none;

  text-decoration: none;

  cursor: pointer;

  transition-property: color, background-color;
  transition: ${({ theme }) => theme.transitionSpeed} ease-in;

  ${({ motive }) => motive && pickMotive(motive)};

  &:disabled,
  &[disabled] {
    background-color: ${pickColor('disabled')};
    color: ${pickColor('textDisabled')};

    cursor: not-allowed;
  }

  span {
    margin-top: 0;
  }
`;
Button.displayName = 'Button';

const ButtonIconLeft = styled(Icon)<StyledButtonIconProps>`
  display: flex;
  align-items: center;

  font-size: ${({ $iconSize }) => `${$iconSize}rem` || '1.2rem'};
`;

const ButtonIconRight = styled(Icon)<StyledButtonIconProps>`
  display: flex;
  align-items: center;

  font-size: ${({ $iconSize }) => `${$iconSize}rem`};
`;

const ButtonLabel = styled(Headline)<StyledButtonProps>`
  display: block;
  
  margin-top: 0.3rem;
  
  white-space: nowrap;
  
  min-width: ${({ minWidth }) => minWidth || 'auto'};
  font-family: ${({ fontFamily }) => `${fontFamily}, sans-serif`};

  ${getFontScale}

  ${ButtonIconLeft} ~ & {
    padding-left: 1rem;
  }

  &:not(:last-of-type) {
    padding-right: 1rem;
  }
`;

export { Button, ButtonLabel, ButtonIconLeft, ButtonIconRight };
